module.exports = __webpack_public_path__ + "img/btn_yellow_hover.727c50be.webp";